export const sortObjectArrayByOrder = <T extends { state: any }>(
  array: T[],
  sortOrder: string[]
): T[] => {
  return array?.sort((a, b) => sortOrder.indexOf(a.state) - sortOrder.indexOf(b.state)) ?? [];
};
